<style lang="scss" scoped>
   /deep/ .ivu-page-disabled a {
        color: #08F4F7;
    }
   /deep/ .ivu-page-next{
       background: rgba(8, 244, 247, 0.2);
   }
   /deep/ .ivu-page-prev {
       background: rgba(8, 244, 247, 0.2);
   }
   /deep/ .ivu-page-item{
       background: rgba(8, 244, 247, 0.2);
       color: #08F4F7;
   }
  /deep/ .ivu-page-item-active:hover a{
       color: #08F4F7;
   }
   /deep/ .ivu-page-item-active a{
       color: #08F4F7;
   }
    .zzuiTable {
        position: relative;
        min-height: 268px;
    }
    .table-bottom {
        margin-top: 20px;
        height: 35px;
        padding-right: 20px;
        width: 100%;
        overflow: hidden;
    }
    .table-btmRight {
        float: right;
    }
    /deep/ table{
        background: none;
        border-collapse: separate; 
        border-spacing: 0px 5px;
    }
    /deep/ table th{
        background: #1B4C4C;
        color: #02E7E7;
    }
   /deep/ .ivu-modal-wrap{
       background: #123333 !important;
       color: #02E7E7;
   }
    /deep/ table td{
        background: #123333;
        color: #02E7E7;
    }
    /deep/ .ivu-select-selection {
        background: rgba(8, 244, 247, 0.2);
        color: #08F4F7;
        border: 0px;
    }
  /deep/ .ivu-icon-ios-arrow-down:before {
        color: #08F4F7;
   }
   /deep/ .ivu-page.mini .ivu-page-options-elevator {
       color: #08F4F7;
   }
    /deep/ .ivu-page-options-elevator input{
        background: rgba(8, 244, 247, 0.2);
        color: #08F4F7;
        border: 0px;
    }
   /deep/ .ivu-table {
       background-color: #fff0;
   }
   /deep/ .ivu-table th {
       border-bottom: 1px solid #275482;
   }
    /deep/ .ivu-table-row:hover{
        background: #123333 !important;
    }
   /deep/ .ivu-table:before {
       background-color: #123333;
   }
  /deep/ .ivu-table-stripe .ivu-table-body td {
       background-color: #1c2b33 !important;
      border-bottom: 1px solid #275482;
   }
</style>
<template>
    <div class="zzuiTable font12">
        <!--表格公用组件模板-->
        <div style="height: 268px;" v-if="bool">
            <Table :height="height" stripe size="small"
                   :columns="columns" :data="dataTable.list" @on-selection-change="selectChange" @on-expand="expandTab">
            </Table>
            <div class="table-bottom" v-if="!pageHide">
                <div class="table-btmRight">
                    <Page :total="dataTable.page.totalCount"
                          @on-change="goPage"
                          :page-size="dataTable.page.pageSize"
                          :current="dataTable.page.currentPage"
                          @on-page-size-change="sizeChange"
                          size="small" show-elevator show-sizer
                    ></Page>
                </div>
            </div>
        </div>
        <div class="center p-t-40" v-else>正在加载...</div>
        <!--<div class="center p-t-40" v-else>查询不到任何相关数据</div>-->
    </div>
</template>
<script>
    export default {
        name:'private-table',
        /*@
        * param columnsList 表格标题字段
        * param dataTable 表格数据
        * param columnsProp 通过条件判断、判断表格配置项
        * param extendColumns 通过新增表格配置项
        * */
        props: {
            'columnsList': {
                type: [Array],
            },
            'dataTable': {
                type: [Object],
            },
            'columnsProp': {
                type: [String, Object],
            },
            'extendColumns': {
                type: [String, Object],
            },
            'extendWidth': {
                type: [Array, Object],
            },
            'pageHide': {
                type: [String, Boolean],
                default: false
            },
            'banHover': {
                type: Boolean,
                default: false
            },
            'height': {
                type: Number
            }
        },
        data() {
            return {
                bool: false,
                columns: [],
            }
        },
        watch: {
            dataTable() {
                if (this.dataTable.page && this.dataTable.list) this.formatData();
            }
        },
        methods: {
            /*列表格式化*/
            formatData() {
                let arr = [];
                this.columnsList.forEach((item, index) => {
                    let obj = {
                        // align: item.align ? item.align : "center",
                        ellipsis: item.ellipsis ? item.ellipsis : true,
                        tooltip:true,
                        render: (h, params) => {
                            return h('span', {
                                attrs: {
                                    title: params.row[item.key]
                                }
                            }, params.row[item.key])
                        }
                    };
                    Object.assign(obj,item);
                    arr.push(obj);
                });
                this.columns = arr;
                this.bool = true;
            },
            /*点击页码更换数据*/
            goPage(val) {
                this.$emit('getPageData', val);
            },
            selectChange (selection) {
                this.$emit('selectChange', selection);
            },
            expandTab(row,status){
                this.$emit('expandTab',{row,status});
            },
            sizeChange(val){
                 this.$emit('sizeChange',val);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/riskRecord/private-table.vue